import '../../../../utils/index.mjs';
import { timePanelSharedProps } from './shared.mjs';
import { buildProps, definePropType } from '../../../../utils/vue/props/runtime.mjs';

const panelTimeRangeProps = buildProps({
  ...timePanelSharedProps,
  parsedValue: {
    type: definePropType(Array)
  }
});

export { panelTimeRangeProps };
//# sourceMappingURL=panel-time-range.mjs.map
